import { createDb, DatabaseProvider } from "../db/db-setup.js";
import { Layout } from "./Layout.js";
import { usePromise } from "../util/usePromise.js";

// const dbSetup = import("../db/db-setup.js");

export const App = () => {
    const db = usePromise(() => createDb());

    return <DatabaseProvider.Provider value={db}>
        <Layout />
    </DatabaseProvider.Provider>
};
